<div class="pt-1 flex flex-nowrap">
  <div class="pt-2 w-full">
    <app-button-atom
      size="M"
      [label]="label"
      (click)="click($event)"
      [type]="style"
      [size]="size"
      [full]="true"
      [link]="action === 'GO_TO_URL' ? linkUrl : null"
    ></app-button-atom>
  </div>
</div>
